<template>
  <v-dialog :value="value" persistent width="500" @click:outside="close()">
    <v-card>
      <v-card-title class="pl-6 pr-2 pt-4 pb-0">
        <v-icon class="mr-2" color="warning">mdi-alert</v-icon>
        <div class="title h6">
          Ad Fee Alert
        </div>
      </v-card-title>
      <v-container fluid class="pa-0">
        <div class="mx-6 my-2">
          <p>The ad fee on this promotion is <span class="font-weight-bold">{{ `$${promo.lump_sum_allowance}` }}</span></p>
          <p class="font-weight-bold">{{ retailerWarning }}</p>
          <p v-if="allowContinue">
            If not, please click continue.
          </p>
        </div>
        <div class="d-flex justify-center">
          <v-btn class="mb-4 mr-4" text @click="close">
            {{ allowContinue ? 'Cancel' : 'Acknowledge' }}
          </v-btn>
          <v-btn v-if="allowContinue" class="mb-4" color="warning" @click="submit">
            Continue
          </v-btn>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import { userAccess } from '@/mixins/user-access'
import { displayAlert } from '@/mixins/alert'
export default {
  name: 'AdFeeAlertModal',
  mixins: [displayAlert, userAccess],
  props: {
    value: Boolean,
    allowContinue: Boolean,
    promo: Object
  },
  computed: {
    retailerWarning() {
      return this.limitAccessByRelatedVendors
        ? 'If this amount is intended to go to a specific retailer, please click cancel and reach out to your ARG category manager.'
        : 'If this amount is intended to go to a specific retailer, please assign to a specific store.'
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    submit() {
      this.$emit('submitWithAdFeeAlert')
    }
  }
}
</script>
<style>
.title {
  width: 73%;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>